import React from 'react'
import LayoutContainer from '../../views/layouts/LayoutContainer'
import Navbar from '../navbar/Navbar'

export default ({ children }) => (
  <div>
    <Navbar to="/mobile"/>
    <LayoutContainer>{children}</LayoutContainer>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/templates/mobileHome/MobileHomeLayout.js